import React from "react";
import { IconButton, InputAdornment, Box } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Controls from "../controlElement/Controls";

export default function Multiline(props) {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        handeOnChange,
        getEvaluatedValue,
        encryptionDecryptions,
        handleEncryptionDecryption
    } = props;

    const value = comp?.rule
        ? getEvaluatedValue(comp.rule)
        : data[controleId] || "";

        // console.log("comp", comp)
    return (
        <Box mb={2}>
            <Controls.Input
                id={controleId}
                name={controleId}
                label={comp.label}
                multiline
                rows={2}
                required={comp.isRequired}
                value={value}
                onChange={handeOnChange}
                disabled={isDisabled}
                error={errors[controleId]}
                data-encryption={comp.encryptionValidate}
                InputProps={{
                    endAdornment: comp.encryptionValidate && (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={() => handleEncryptionDecryption(controleId)}
                            >
                                {encryptionDecryptions[controleId] === "" ? (
                                    <VisibilityOff fontSize="small" />
                                ) : (
                                    <Visibility fontSize="small" />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ),
                    sx: {
                        backgroundColor: isDisabled ? "#f8fafc" : (!value ? "#f8fafc" : "#ffffff"),
                        "&.Mui-disabled": {
                            backgroundColor: "#f8fafc",
                            cursor: "not-allowed",
                        },
                    }
                }}
                sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#1e293b !important",
                        color: "#1e293b !important",
                        opacity: 1,
                    },
                    "& .MuiInputLabel-root.Mui-disabled": {
                        color: "#1e293b !important",
                        opacity: 1,
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#cbd5e1 !important",
                    },
                    "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: "#f8fafc",
                        cursor: "not-allowed",
                    },
                    '& .MuiInputBase-root textarea': {
                        resize: 'both', // or 'vertical' or 'horizontal' as per your need
                        overflow: 'auto'
                    },
                     "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                }}
                className={comp?.cssclass || ""}
            />
        </Box>
    );
}
